import { render, staticRenderFns } from "./SocialValueList.vue?vue&type=template&id=0e686d3c&scoped=true&"
import script from "./SocialValueList.vue?vue&type=script&lang=js&"
export * from "./SocialValueList.vue?vue&type=script&lang=js&"
import style0 from "./SocialValueList.vue?vue&type=style&index=0&id=0e686d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e686d3c",
  null
  
)

export default component.exports